import React, { useContext, useState, useEffect } from "react";
import { ApiContext } from "../apiContext";
import { FaEye, FaEdit, FaTrashAlt } from "react-icons/fa";
import Service from "./Service";
import ViewForm from "./ViewForm";
import axios from "axios";
import { getToken } from "../../auth/AuthService";
import DeleteBox from "../DeleteBox";
import { useLoader } from "../../helper/Loader";
import notify from "../../helper/Notify";
import htmlTruncate from "html-truncate"

function GlossaryAPi({ page = 1, pageSize, searchQuery, totalLength }) {
  const { data, setData, error } = useContext(ApiContext);
  const [filteredBlog, setFilteredBlog] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const token = getToken();
  const closeModal = () => setShowModal(false);
  const modalClose = () => setEditModal(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteCandidate, setDeleteCandidate] = useState(null);
  const{setIsLoader} = useLoader();
  const apiBaseUrl = window.API_CONFIG.All_Api.glossary;

  useEffect(() => {
    try {
      if (!data.glossary || data.glossary.length === 0) {
        throw new Error("No data available");
      }

      const filteredData = data.glossary.filter((item) => {
        const name = item?.title ?? "";
        return name.toLowerCase().includes(searchQuery.toLowerCase());
      });

      const sortedData = filteredData.sort(
        (a, b) =>
          {
            const dateA = a.updatedDate ? new Date(a.updatedDate) : new Date(a.createdDate);
            const dateB = b.updatedDate ? new Date(b.updatedDate) : new Date(b.createdDate);
            return dateB - dateA; 
      }
      );

      setFilteredBlog(sortedData);
      totalLength(filteredData.length);
    } catch (error) {
      console.error("Error fetching or processing data:", error);
    }
  }, [data.glossary, searchQuery, page, pageSize, totalLength]);
  /* Handle Remove function */

  const confirmDelete = async () => {
    setShowDeleteModal(false);
    const apiUrl = `${apiBaseUrl}/${deleteCandidate}`;
    setIsLoader(true)

    try {

      const response = await axios.delete(apiUrl);
      console.log("Delete response:", response.data);

     
      const updatedDataResponse = await axios.get(apiBaseUrl, {
        headers: {
          "x-access-token": token,
        },
      });
      const updatedDataFromServer =
        updatedDataResponse.data.data?.ViewModels || [];
      setData((prevData) => ({
        ...prevData,
        glossary: updatedDataFromServer,
      }));
      notify.success("Data removed successfully");
    } catch (error) {
      // Handle any errors here
      console.error(error.message);
    }
    setIsLoader(false)
  };
  const handleRemover = async (id) => {
    setDeleteCandidate(id);
    setShowDeleteModal(true);
  };
  const cancelDelete = () => {
    setShowDeleteModal(false);
    setDeleteCandidate(null);
  };

  function generateApiUrl(fileName) {
    return `${apiBaseUrl}/${fileName}`;
  }
  if (error) {
    return <div>Error: {error.message}</div>;
  } else {
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    const items = filteredBlog
      .slice(startIndex, endIndex)
      .map((viewModel, index) => {
        const id = `item-${index}`,
          apiUrl = generateApiUrl(viewModel.fileName);

        const fetchData = async () => {
          try {
            const response = await fetch(apiUrl);
            const data = await response.json();
            // Process the fetched data here
            console.log(data.data);
            setModalData(data.data);
          } catch (error) {
            // Handle any errors that occur during the fetch
            console.error(error);
          }
        };
        return (
          <tr key={id}>
            <td
              title="View"
              className="view"
              onClick={() => {
                setShowModal(true);
                fetchData();
              }}
            >
              <FaEye />
            </td>
            <td
              title="Edit"
              className="edit"
              onClick={() => {
                setEditModal(true);
                fetchData();
              }}
            >
              <FaEdit />
            </td>
            <td
              title="Delete"
              className="delete"
              onClick={() => handleRemover(viewModel.fileName)}
            >
              <FaTrashAlt />
            </td>
            <td title ={viewModel.title} width="25%">
              {viewModel && viewModel.title
                ? `${viewModel.title.substring(0, 20)}...`
                : "Title not available"}
            </td>

            <td width="33%">
              {viewModel.shortdescription ? (
                 <div
                 dangerouslySetInnerHTML={{
                   __html: htmlTruncate(viewModel.shortdescription, 50), 
                 }}
               
                 />
              ) : (
                "Description not available"
              )}
            </td>
            <td width="16%">
              {new Date(viewModel.updatedDate || viewModel.createdDate)
                .toISOString()
                .slice(0, 10)}
            </td>
            <td width="10%">
              <span
                className={`status ${viewModel.status ? "active" : "inactive"}`}
              >
                {viewModel.status ? "active" : "inactive"}
              </span>
            </td>
            {showModal && (
              <ViewForm Modalclose={closeModal} modalData={modalData} />
            )}
            {editModal && (
              <Service
                closeModal={modalClose}
                modalData={modalData}
                setModalData={setModalData}
                setFilteredBlog={setFilteredBlog}
              />
            )}
          </tr>
        );
      });

    return (
      <>
        <tbody>
        {filteredBlog.length === 0 ? (
          <tr>
          <td classname ="noFound" colSpan="12">No data found</td>
          </tr>
        ) : (
          items
        )}
          {showDeleteModal && (
            <DeleteBox Modalclose={cancelDelete} handleDelete={confirmDelete} />
          )}
        </tbody>
      </>
    );
  }
}
export const GlossaryLength = () => {
  const { data } = useContext(ApiContext);
  return data.glossary.length;
};
export default GlossaryAPi;
